import { MaskConfig } from '../types';

export function getFullMaskStr(config: MaskConfig): string {
	const orderedMasks = config.order.map(prop => config.parts[prop].mask);
	return orderedMasks.join(config.delimiterChar);
}
